import { FieldPath, FormState } from '@form-ts/core';
import { pipe } from 'fp-ts/function';
import { modify } from 'monocle-ts/Lens';

export function modifyField<TData, TError, TValue>(
  field: FieldPath<TData, TError, TValue>,
  modifier: (value: TValue) => TValue,
): (formData: FormState<TData, TError>) => FormState<TData, TError> {
  return pipe(field.value, modify(modifier));
}
